import $gkwyr$intlsliderarAEmjs from "../intl/slider/ar-AE.mjs";
import $gkwyr$intlsliderbgBGmjs from "../intl/slider/bg-BG.mjs";
import $gkwyr$intlslidercsCZmjs from "../intl/slider/cs-CZ.mjs";
import $gkwyr$intlsliderdaDKmjs from "../intl/slider/da-DK.mjs";
import $gkwyr$intlsliderdeDEmjs from "../intl/slider/de-DE.mjs";
import $gkwyr$intlsliderelGRmjs from "../intl/slider/el-GR.mjs";
import $gkwyr$intlsliderenUSmjs from "../intl/slider/en-US.mjs";
import $gkwyr$intlslideresESmjs from "../intl/slider/es-ES.mjs";
import $gkwyr$intlslideretEEmjs from "../intl/slider/et-EE.mjs";
import $gkwyr$intlsliderfiFImjs from "../intl/slider/fi-FI.mjs";
import $gkwyr$intlsliderfrFRmjs from "../intl/slider/fr-FR.mjs";
import $gkwyr$intlsliderheILmjs from "../intl/slider/he-IL.mjs";
import $gkwyr$intlsliderhrHRmjs from "../intl/slider/hr-HR.mjs";
import $gkwyr$intlsliderhuHUmjs from "../intl/slider/hu-HU.mjs";
import $gkwyr$intlslideritITmjs from "../intl/slider/it-IT.mjs";
import $gkwyr$intlsliderjaJPmjs from "../intl/slider/ja-JP.mjs";
import $gkwyr$intlsliderkoKRmjs from "../intl/slider/ko-KR.mjs";
import $gkwyr$intlsliderltLTmjs from "../intl/slider/lt-LT.mjs";
import $gkwyr$intlsliderlvLVmjs from "../intl/slider/lv-LV.mjs";
import $gkwyr$intlslidernbNOmjs from "../intl/slider/nb-NO.mjs";
import $gkwyr$intlslidernlNLmjs from "../intl/slider/nl-NL.mjs";
import $gkwyr$intlsliderplPLmjs from "../intl/slider/pl-PL.mjs";
import $gkwyr$intlsliderptBRmjs from "../intl/slider/pt-BR.mjs";
import $gkwyr$intlsliderptPTmjs from "../intl/slider/pt-PT.mjs";
import $gkwyr$intlsliderroROmjs from "../intl/slider/ro-RO.mjs";
import $gkwyr$intlsliderruRUmjs from "../intl/slider/ru-RU.mjs";
import $gkwyr$intlsliderskSKmjs from "../intl/slider/sk-SK.mjs";
import $gkwyr$intlsliderslSImjs from "../intl/slider/sl-SI.mjs";
import $gkwyr$intlslidersrSPmjs from "../intl/slider/sr-SP.mjs";
import $gkwyr$intlslidersvSEmjs from "../intl/slider/sv-SE.mjs";
import $gkwyr$intlslidertrTRmjs from "../intl/slider/tr-TR.mjs";
import $gkwyr$intlsliderukUAmjs from "../intl/slider/uk-UA.mjs";
import $gkwyr$intlsliderzhCNmjs from "../intl/slider/zh-CN.mjs";
import $gkwyr$intlsliderzhTWmjs from "../intl/slider/zh-TW.mjs";

var $23a91f0f3f204481$exports = {};


































$23a91f0f3f204481$exports = {
    "ar-AE": $gkwyr$intlsliderarAEmjs,
    "bg-BG": $gkwyr$intlsliderbgBGmjs,
    "cs-CZ": $gkwyr$intlslidercsCZmjs,
    "da-DK": $gkwyr$intlsliderdaDKmjs,
    "de-DE": $gkwyr$intlsliderdeDEmjs,
    "el-GR": $gkwyr$intlsliderelGRmjs,
    "en-US": $gkwyr$intlsliderenUSmjs,
    "es-ES": $gkwyr$intlslideresESmjs,
    "et-EE": $gkwyr$intlslideretEEmjs,
    "fi-FI": $gkwyr$intlsliderfiFImjs,
    "fr-FR": $gkwyr$intlsliderfrFRmjs,
    "he-IL": $gkwyr$intlsliderheILmjs,
    "hr-HR": $gkwyr$intlsliderhrHRmjs,
    "hu-HU": $gkwyr$intlsliderhuHUmjs,
    "it-IT": $gkwyr$intlslideritITmjs,
    "ja-JP": $gkwyr$intlsliderjaJPmjs,
    "ko-KR": $gkwyr$intlsliderkoKRmjs,
    "lt-LT": $gkwyr$intlsliderltLTmjs,
    "lv-LV": $gkwyr$intlsliderlvLVmjs,
    "nb-NO": $gkwyr$intlslidernbNOmjs,
    "nl-NL": $gkwyr$intlslidernlNLmjs,
    "pl-PL": $gkwyr$intlsliderplPLmjs,
    "pt-BR": $gkwyr$intlsliderptBRmjs,
    "pt-PT": $gkwyr$intlsliderptPTmjs,
    "ro-RO": $gkwyr$intlsliderroROmjs,
    "ru-RU": $gkwyr$intlsliderruRUmjs,
    "sk-SK": $gkwyr$intlsliderskSKmjs,
    "sl-SI": $gkwyr$intlsliderslSImjs,
    "sr-SP": $gkwyr$intlslidersrSPmjs,
    "sv-SE": $gkwyr$intlslidersvSEmjs,
    "tr-TR": $gkwyr$intlslidertrTRmjs,
    "uk-UA": $gkwyr$intlsliderukUAmjs,
    "zh-CN": $gkwyr$intlsliderzhCNmjs,
    "zh-TW": $gkwyr$intlsliderzhTWmjs
};


export {$23a91f0f3f204481$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
